export enum ScopeType {
    ScopeToggled = 'ScopeToggled',
    ScopeReset = 'ScopeReset',
}

export interface ScopeToggledAction {
    type: ScopeType.ScopeToggled;
    scope: string;
}

export interface ScopeResetAction {
    type: ScopeType.ScopeReset;
}

export const scopeToggled = (scope: string): ScopeToggledAction => ({
    type: ScopeType.ScopeToggled,
    scope,
});

export const scopeReset = (): ScopeResetAction => ({
    type: ScopeType.ScopeReset,
});

export type ScopeActionTypes = ScopeToggledAction | ScopeResetAction;
